import type { ReactNode } from "react";

import { ErrorPage } from "./ErrorPage";

type ForbiddenpageProps = {
    description?: ReactNode;
};

export const Forbiddenpage = (props: ForbiddenpageProps) => {
    const { description } = props;

    return <ErrorPage kind="accessDenied" description={description} />;
};
